import React from "react";
import Reveal from "./Reveal";
import { useLang } from "../lib/lang-context";
import { Check } from "@phosphor-icons/react";

export default function About() {
  const { t } = useLang();
  const bullets = [t.about.bullet1, t.about.bullet2, t.about.bullet3, t.about.bullet4];
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-white dark:bg-zinc-950 border-t border-slate-200 dark:border-zinc-800"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Image — asymmetric */}
          <Reveal variant="left" className="lg:col-span-6 relative">
            <div
              className="relative overflow-hidden border border-slate-200 dark:border-zinc-800"
              style={{ borderRadius: 4 }}
            >
              <img
                src="https://images.pexels.com/photos/5860937/pexels-photo-5860937.jpeg"
                alt="Modern medical distribution warehouse"
                className="w-full aspect-[4/5] object-cover"
                data-testid="about-image"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-[var(--icor-navy)]/30 via-transparent to-transparent" />
            </div>
            {/* Floating metric */}
            <div
              className="absolute -bottom-6 -right-6 hidden md:block bg-[var(--icor-navy)] text-white p-6 lg:p-8 max-w-xs shadow-2xl"
              style={{ borderRadius: 4 }}
            >
              <div className="font-display text-4xl lg:text-5xl font-bold tracking-tighter">
                99.4%
              </div>
              <div className="text-xs uppercase tracking-[0.18em] text-white/60 mt-2">
                {t.about.metricLabel}
              </div>
            </div>
          </Reveal>

          {/* Content */}
          <Reveal variant="right" delay={150} className="lg:col-span-6">
            <p className="text-xs tracking-[0.24em] uppercase font-bold text-[var(--icor-blue)] eyebrow-line">
              {t.about.eyebrow}
            </p>
            <h2 className="font-display text-4xl md:text-5xl font-semibold tracking-tighter mt-5 text-[var(--icor-navy)] dark:text-white text-balance">
              {t.about.title}
            </h2>
            <p className="mt-6 text-lg text-slate-600 dark:text-zinc-400 leading-relaxed">
              {t.about.p1}
            </p>
            <p className="mt-4 text-base text-slate-500 dark:text-zinc-500 leading-relaxed">
              {t.about.p2}
            </p>

            <ul className="mt-8 grid sm:grid-cols-2 gap-3">
              {bullets.map((b, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3"
                  data-testid={`about-bullet-${i}`}
                >
                  <span
                    className="mt-1 flex-shrink-0 w-5 h-5 flex items-center justify-center"
                    style={{
                      background: "var(--icor-blue)",
                      color: "white",
                      borderRadius: 2,
                    }}
                  >
                    <Check size={12} weight="bold" />
                  </span>
                  <span className="text-sm text-slate-700 dark:text-zinc-300">{b}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
